import React, { useContext, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import PerfectScrollbar from "react-perfect-scrollbar";
import Menus from './Menus';
import { NavigationContext } from '../../contentApi/NavigationProvider';

const NavigationManu = () => {
    const { navigationOpen, setNavigationOpen } = useContext(NavigationContext)
    const pathName = useLocation().pathname
    useEffect(() => {
        setNavigationOpen(false)
    }, [pathName])
    return (
        <nav className={`nxl-navigation ${navigationOpen ? "mob-navigation-active" : ""}`}>
            <div className="navbar-wrapper">
                <div className="m-header">
                    <Link to="/home" className="b-brand">
                        {/* <!-- ========   change your logo hear   ============ --> */}
                        {/* <h2 className="logo logo-lg">Loan Matrix</h2> */}
                        {/* <h4 className="logo logo-sm" >LM</h4> */}
                        <img src="/images/lm_logo.png" alt="logo" className="logo logo-lg" style={{ width: '212px' }} />
                        {/* <img src="/images/logo/demo-logo.webp" alt="logo" className="logo logo-sm"  style={{ width: '212px' }} /> */}
                    </Link>
                </div>

                <div className={`navbar-content`}>
                    <PerfectScrollbar>
                        <ul className="nxl-navbar">
                            {/* <li className="nxl-item nxl-caption">
                                <label>Navigation</label>
                            </li> */}
                            <Menus />
                        </ul>
                        {/* <div className="card text-center">
                            <div className="card-body">
                                <i className="fs-4 text-dark"><FiSunrise /></i>
                                <h6 className="mt-4 text-dark fw-bolder">Downloading Center</h6>
                                <p className="fs-11 my-3 text-dark">Duralux is a production ready CRM to get started up and running easily.</p>
                                <Link to="#" className="btn btn-primary text-dark w-100">Download Now</Link>
                            </div>
                        </div> */}
                        <div style={{ height: "18px" }}></div>
                    </PerfectScrollbar>
                </div>
            </div>
            <div onClick={() => setNavigationOpen(false)} className={`${navigationOpen ? "nxl-menu-overlay" : ""}`}></div>
        </nav>
    )
}

export default NavigationManu